import React from "react";
import { CircleSlash } from "lucide-react";
import { EmptyDataProps } from "./interfaces";

export const EmptyData: React.FC<EmptyDataProps> = ({ description, title }) => (
  <div className="flex h-[calc(60vh-4rem)] items-center justify-center overflow-y-hidden md:h-[70vh]">
    <div className="flex flex-col items-center px-5 text-center md:px-4">
      <CircleSlash className="h-12 w-12 shrink-0 stroke-gray-300 stroke-[1.5]" />
      <p className="pt-2 text-sm text-gray-500 md:text-base xl:text-lg">
        {title}
      </p>
      {description && (
        <p className="text-sm text-gray-400 md:text-base">{description}</p>
      )}
    </div>
  </div>
);
